import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { getGoogleMapsAPIKey } from 'helpers/api';
import React from 'react';
import { MapProps, MarkerType } from '../types';

const containerStyle = {
  width: '100%',
  height: '100%',
  minHeight: '500px',
};

const CASABLANCA = {
  lat: 33.5951789,
  lng: -7.6222771,
};

const CustomMap = ({
  center = CASABLANCA,
  markers,
  setSelected,
  selected,
}: MapProps) => {
  const filteredMarkers =
    selected != null
      ? markers.filter((item: MarkerType) => item.id === selected)
      : markers;
  return (
    <LoadScript googleMapsApiKey={getGoogleMapsAPIKey()}>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
        {filteredMarkers.map(
          ({ position, icon, id }: MarkerType, index: number) => {
            return (
              <Marker
                icon={icon}
                position={position}
                key={index}
                onClick={() => setSelected!(id)}
              />
            );
          },
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default React.memo(CustomMap);
